import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { compose } from 'react-recompose';

import { loadMoreAMConnectionsProp, SimpleLoadingComponent } from '../../utils/apollo';

import AMConnectionsView from './connections-view';
import { STUDENT_CONNECTION_FRAGMENT, LIMIT } from './constants';
import { queryErrorsToWarnings } from '../../components/GraphQLError';

const query = gql`
  query AMPlusRecentConnections ($recentDays: Int, $page: Int, $limit: Int) {
    viewer {
      id
      enabledFeatures
      studentConnections: amStudentConnectionsRecent(page: $page, limit: $limit, recentDays: $recentDays) {
        pagination {
          page
          totalCount
          hasNextPage
        }
        results {
          ...AMStudentResults
        }
      }
    }
  }
  ${STUDENT_CONNECTION_FRAGMENT}
`;

const graphqlData = graphql(query, {
  options: ({ recentDays=0 }) => ({
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
    variables: {
      page: 1,
      limit: LIMIT,
      recentDays,
    },
  }),
  props: compose(
    queryErrorsToWarnings(['studentConnections']),
    loadMoreAMConnectionsProp(query),
  ),
});

export default SimpleLoadingComponent(graphqlData)(AMConnectionsView);
